let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("Gx3zW")).then(() => parcelRequire('8l3CP'));